import { useEffect } from 'react';
import { useUsuarioStore } from '../store/usuarioStore';
import { useAuthReady } from './useAuthReady';

export const useUsuarioInit = () => {
  const { fetchUsuario } = useUsuarioStore();
  const isAuthReady = useAuthReady();

  useEffect(() => {
    if (!isAuthReady) return;
    
    fetchUsuario({ silent: true });
  }, [isAuthReady, fetchUsuario]);
}; 